/**
 * <multi-add-cart-button 
  data-products='[
    {"variantId": "123456789", "quantity": 2},
    {"variantId": "987654321", "quantity": 1},
    {"variantId": "112233445", "quantity": 3}
  ]'
>
  批量添加选中产品
</multi-add-cart-button>
 */
if (!customElements.get("multi-add-cart-button")) {
  class MultiAddCartButton extends HTMLElement {
    // 获取产品数据属性
    get _products() {
      const productsData = this.getAttribute('data-products');
      if (!productsData) return [];
      
      try {
        return JSON.parse(productsData);
      } catch (e) {
        console.error('产品数据格式错误:', e);
        return [];
      }
    }

    constructor() {
      super();
      // 保存绑定的方法引用，确保 add/remove 使用同一引用
      this._boundAddToCart = this.addMultipleToCart.bind(this);
    }
    get _type() {
      return this.getAttribute('data-type') || ''; 
    }
    connectedCallback() {
      this.removeEventListener('click', this._boundAddToCart);
      this.addEventListener('click', this._boundAddToCart);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this._boundAddToCart);
    }

    async addMultipleToCart(event) {
      event?.preventDefault();
      if (this.hasAttribute('loading')) return;

      const products = this._products;
      
      if (!products.length) {
        alert("Please select the product first")
        console.warn('没有要添加的产品');
        return;
      }
      const items = products.map(product => ({
        id: parseInt(product.variantId, 10),
        quantity: Math.max(1, parseInt(product.quantity || 1, 10)) 
      })).filter(item => !isNaN(item.id)); 

      if (!items.length) {
        console.error('没有有效的产品变体ID');
        return;
      }

      const source =
        event?.target?.closest?.('button, a, [role="button"]') ||
        this.querySelector('button, a, [role="button"]') ||
        document.activeElement;

      this.setLoading(true, source);

      try {
        if (typeof window.CartDrawer?.addAndOpen !== 'function') {
          throw new Error('Cart drawer is unavailable');
        }

        await window.CartDrawer.addAndOpen(items, {
          source,
          checkout: this._type === 'checkout',
        });
      } catch (error) {
        console.error('加购错误:', error);
        alert(`error: ${window.CartApi?.getErrorMessage?.(error, 'Unable to add item to cart.') || 'Unable to add item to cart.'}`);
      } finally {
        this.setLoading(false, source);
      }
    }

    /**
     * 加购期间锁定实际触发控件，避免重复提交。
     */
    setLoading(value, source) {
      this.toggleAttribute('loading', value);
      this.setAttribute('aria-busy', value ? 'true' : 'false');

      if (source) {
        if ('disabled' in source) source.disabled = value;
        source.setAttribute('aria-busy', value ? 'true' : 'false');
      }
    }
  }

  customElements.define('multi-add-cart-button', MultiAddCartButton);
}
